import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8955b0f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "text-3xl text-center mb-2" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 公式のお知らせ ")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "news-title py-3" }
const _hoisted_7 = {
  key: 1,
  class: "text-md text-center py-5 news-title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      _createVNode(_component_fa, { icon: "bullhorn" }),
      _hoisted_3
    ]),
    (_ctx.news_data.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.news_data, (news) => {
            return (_openBlock(), _createElementBlock("div", {
              key: news.url
            }, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: news.url,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, [
                  _createElementVNode("p", _hoisted_6, _toDisplayString(news.title), 1)
                ], 8, _hoisted_5)
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_7, " 関連する最近のお知らせはありません。 "))
  ]))
}